import { render, staticRenderFns } from "./info-inquiry.vue?vue&type=template&id=034c4f3e"
import script from "./info-inquiry.vue?vue&type=script&lang=js"
export * from "./info-inquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports